import PropTypes from 'prop-types';

/**
 * @typedef {Object} ContentItem
 * @memberof module:react/propTypes
 * @prop {string} assetUrl Location of the content file
 * @prop {string} author Author of the file
 * @prop {string} category Category of the content
 * @prop {string} description Description of the content
 * @prop {string} fileName File name
 * @prop {number} fileSize Size of the file
 * @prop {string} id Content id
 * @prop {string} imageSize Dimension of the image
 * @prop {boolean} isFavorite True if the asset is marked as a favorite.
 * @prop {string} linking Linked services
 * @prop {string} provider Provider of the content
 * @prop {string} smallThumbnailUrl Small thumbnail url
 * @prop {string} subclass subclass
 * @prop {string} subject Subject of the image
 * @prop {string} thumbnailUrl Standard size thumbnail url
 * @prop {string} title Asset title.
 */
export default PropTypes.shape({
  assetUrl: PropTypes.string,
  author: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.number),
  description: PropTypes.string,
  fileName: PropTypes.string,
  fileSize: PropTypes.number,
  id: PropTypes.string.isRequired,
  imageSize: PropTypes.string,
  isFavorite: PropTypes.bool.isRequired,
  keywords: PropTypes.string,
  lastModifiedDate: PropTypes.string,
  linking: PropTypes.string,
  provider: PropTypes.string,
  smallThumbnailUrl: PropTypes.string,
  subclass: PropTypes.string,
  subject: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  title: PropTypes.string
});



// WEBPACK FOOTER //
// ./app/propTypes/contentItem.js